import { CustomFieldAttributes, CustomFieldField, CustomFieldResource } from '@/types'
import { UpdateCustomFieldMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditCustomFieldQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { ErrorMessage, Field, Label } from '../base/fieldset'
import { Selector as ResourceTypeSelector } from './resource_type/selector'
import { Selector as FieldTypeSelector } from './field_type/selector'

type CustomField = EditCustomFieldQuery['customFields']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
    fieldErrors,
    attributes,
    setAttributes
  } = useForm<UpdateCustomFieldMutation, CustomFieldAttributes, EditCustomFieldQuery, CustomField>({
    id,
    initializer: customField => ({
      name: customField.name,
      resourceType: customField.resourceType,
      fieldType: customField.fieldType,
      enabled: customField.enabled
    }),
    query: EditQuery,
    queryKey: 'customFields',
    mutation: UpdateMutation,
    resultKey: 'updateCustomField'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        <div className="grid grid-cols-2 gap-6">
          <Field>
            <Label>Resource</Label>
            <ResourceTypeSelector
              invalid={!!fieldErrors?.resourceType}
              value={attributes.resourceType}
              onChange={value => setAttributes({ ...attributes, resourceType: value?.id as CustomFieldResource || CustomFieldResource.AssetType }) }
            />
            { fieldErrors?.resourceType && <ErrorMessage>{ fieldErrors?.resourceType }</ErrorMessage> }
          </Field>
          <Field>
            <Label>Field type</Label>
            <FieldTypeSelector
              invalid={!!fieldErrors?.fieldType}
              value={attributes.fieldType}
              onChange={value => setAttributes({ ...attributes, fieldType: value?.id as CustomFieldField || CustomFieldField.Boolean }) }
            />
            { fieldErrors?.fieldType && <ErrorMessage>{ fieldErrors?.fieldType }</ErrorMessage> }
          </Field>
        </div>
        { formBuilder.buildField({ name: 'Enabled', field: 'enabled', type: 'switch' }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
